(() => {
  const text = (element) => element.textContent.replace(/\s+/g, ' ').trim();
  function generate() {
    const root = document.querySelector('.article-content-container, [data-blog-content]');
    if (!root) return;
    const heading = root.querySelector('h2[data-blog-faq], h2#faq') || [...root.querySelectorAll('h2')].find((item) => /^frequently asked questions\s*\??$/i.test(text(item)));
    document.getElementById('blog-faq-schema')?.remove();
    if (!heading) return;
    const mainEntity = [];
    let question = '';
    let answers = [];
    const save = () => {
      const answer = answers.join('\n\n').trim();
      if (question && answer) mainEntity.push({ '@type': 'Question', name: question, acceptedAnswer: { '@type': 'Answer', text: answer } });
    };
    for (let item = heading.nextElementSibling; item && !item.matches('h1, h2'); item = item.nextElementSibling) {
      if (item.matches('h3, h4')) {
        save();
        question = text(item);
        answers = [];
      } else if (question && item.matches('p, ul, ol, blockquote')) {
        answers.push(item.matches('ul, ol') ? [...item.children].map(text).join('\n') : text(item));
      }
    }
    save();
    if (!mainEntity.length) return;
    // Replace only legacy standalone FAQ schema inside the article.
    root.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
      try {
        if (JSON.parse(script.textContent)['@type'] === 'FAQPage') script.remove();
      } catch (_) { /* Leave unrelated malformed JSON untouched. */ }
    });
    const script = document.createElement('script');
    script.id = 'blog-faq-schema';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity });
    document.head.appendChild(script);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', generate, { once: true });
  else generate();
  document.addEventListener('shopify:section:load', generate);
})();
